import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { AlertTriangle, Check, Clock } from 'lucide-react';
import { fmtDate, urgencyBadge, categoryLabel } from './alertsShared';

export default function AlertsLoginPopup({ open, alerts, onClose, onManage }) {
  const [items, setItems] = useState(null);
  const list = items !== null ? items : (alerts || []);

  const auth = () => ({ headers: { Authorization: `Bearer ${sessionStorage.getItem('access_token')}` } });
  const API = process.env.REACT_APP_BACKEND_URL + '/api';

  const act = async (id, kind) => {
    try {
      if (kind === 'resolve') { await axios.post(`${API}/admin/alerts/${id}/resolve`, {}, auth()); toast.success('Resolvido ✅'); }
      else { await axios.post(`${API}/admin/alerts/${id}/snooze`, { days: 7 }, auth()); toast.success('Adiado 7 dias'); }
      const next = list.filter((a) => a.id !== id);
      setItems(next);
      if (next.length === 0) onClose();
    } catch { toast.error('Erro na ação'); }
  };

  if (!open || list.length === 0) return null;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="alerts-login-popup">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="w-5 h-5" /> Alertas que precisam de atenção
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-2 max-h-[50vh] overflow-y-auto">
          {list.map((a) => {
            const ub = urgencyBadge(a);
            return (
              <div key={a.id} data-testid={`popup-alert-${a.id}`} className="rounded-lg border p-2.5">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${ub.cls}`}>{ub.text}</span>
                  <span className="text-xs text-slate-500">{categoryLabel(a)}</span>
                </div>
                <div className="text-sm font-semibold text-slate-800">{a.title}</div>
                <div className="text-xs text-slate-500 mb-2">📅 {fmtDate(a.alert_date)}{a.truck_label ? ` · ${a.truck_label}` : ''}</div>
                <div className="flex gap-2">
                  <Button size="sm" variant="outline" className="h-7 text-xs px-2 text-emerald-700" data-testid={`popup-resolve-${a.id}`} onClick={() => act(a.id, 'resolve')}>
                    <Check className="w-3 h-3 mr-1" /> Resolver
                  </Button>
                  <Button size="sm" variant="outline" className="h-7 text-xs px-2" data-testid={`popup-snooze-${a.id}`} onClick={() => act(a.id, 'snooze')}>
                    <Clock className="w-3 h-3 mr-1" /> Adiar 7d
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="popup-close-btn">Fechar</Button>
          <Button onClick={onManage} data-testid="popup-manage-btn">Ver todos os alertas</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
